export default __webpack_public_path__ + "static/media/green-circle-tick.e9f5bfb5.svg";